// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__m2dg-","modalForm":"UpgradeEpcsModal_modalForm__39s8X","modalFooter":"UpgradeEpcsModal_modalFooter__kZ_Hx"};